import script from "./recoverpass.vue?vue&type=script&setup=true&lang=js"
export * from "./recoverpass.vue?vue&type=script&setup=true&lang=js"

import "./recoverpass.vue?vue&type=style&index=0&id=454bdb5c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-454bdb5c"]])

export default __exports__